import React from 'react';
import { observer } from 'mobx-react';
import { Input, Box, IconButton, Typography } from '@material-ui/core';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';

const IncDecNumberInput = observer(({ name, value, onChange, smallLabel }) => {
    const inc = () => {
        onChange(name, parseInt(value || 5) + 1);
    };

    const dec = () => {
        if (value > 5) {
            onChange(name, parseInt(value || 5) - 1);
        }
    };

    const handleChange = e => {
        if (value !== e.target.value) {
            const value = e.target.value;

            if (value >= 5) {
                onChange(name, parseInt(value));
            } else {
                onChange(name, 5);
            }
        }
    };

    return (
        <Box width="100%">
            <Box textAlign="left">
                <Typography variant={smallLabel ? 'caption' : 'body1'}>Период аренды, часов</Typography>
            </Box>
            <Box display="flex" alignItems="center">
                <Box flex={1} mr={2}>
                    <Input name={name} value={value || 5} onChange={handleChange} placeholder="Период аренды, часов" fullWidth />
                </Box>
                <Box mr={1}>
                    <IconButton size="small" onClick={dec}>
                        <RemoveIcon />
                    </IconButton>
                </Box>
                <IconButton size="small" onClick={inc}>
                    <AddIcon />
                </IconButton>
            </Box>
        </Box>
    );
});

export default IncDecNumberInput;
